import React from 'react';
import Table from '@splunk/dashboard-visualizations/Table';

export default () => (
    <Table
        options={{
            numberPrecision: 3,
            useThousandSeparators: false,
            unit: '$$',
            unitPosition: 'after',
            fields: {
                outcome: {
                    unit: 'BitCoin',
                    unitPosition: 'before',
                },
            },
        }}
        encoding={{
            columns: ['primary.income', 'primary.outcome'],
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'income' }, { name: 'outcome' }],
                    columns: [
                        [10000, 24000, 12128192],
                        [50000, 24000, 127828987],
                    ],
                },
                meta: { totalCount: 10 },
            },
        }}
    />
);
